﻿import $ from "jquery";
import * as popperjs from "@popperjs/core"; // required by Bootstrap
import * as bootstrap from "bootstrap";

export function signOutOfClients(signOutUrls: string[]): void {
    if (signOutUrls && signOutUrls.length > 0) {
        const requests = [];
        for (var i = 0; i < signOutUrls.length; i++) {
            const signOutUrl = signOutUrls[i];
            const request = $.ajax(
                signOutUrl,
                {
                    xhrFields: {
                        withCredentials: true
                    }
                });
            requests.push(request);
        }
        $.when(requests).then(() => {
            $(".js-signing-out").hide();
            $(".js-signed-out").show();
        });
    }
}

export function toggle(selector: string): void {
    $(selector).toggle();
}

function enablePopovers(): void {
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))
}

enablePopovers();
